import React, { useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import { Row, Col, Card, CardBody, Input, Label } from "reactstrap"
import API from "../../api/axios"
import moment from "moment"
import { toast } from "react-toastify"

import { MDBDataTable } from "mdbreact"

const AppointmentDetails = () => {
  const { id } = useParams()
  const location = useLocation()

  const [patientData, setPatientData] = useState([])

  const [statusList, setStatus] = useState([])

  const [patientAppointments, setPatientAppointments] = useState([])
  const appointmentData = location.state?.appointmentData || {}
  const [selectedStatusId, setSelelctedStatusId] = useState(
    String(appointmentData.statusId || ""),
  )

  console.log("appointment data 😁", appointmentData)

  const fetchstatus = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const res = await API.get(`/statusList`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setStatus(res.data.status || [])
    } catch (error) {
      console.error("Error fetching status", error.message)
    }
  }

  useEffect(() => {
    fetchstatus()
  }, [])

  //...... update status on the backend.........
  const updateStatus = async newStatusId => {
    try {
      const token = localStorage.getItem("authToken")
      await API.put(
        `/appointments/${appointmentData.id}`,
        { statusId: newStatusId },
        { headers: { Authorization: `Bearer ${token}` } },
      )
      toast.success("status updated")
    } catch (err) {
      console.error("status update failed", err)
      toast.error("could not update status")
    }
  }

  const fetchPatientInfo = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const res = await API.get(
        `/patients/${appointmentData.patientId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      // console.log("patient information by id 😄😄",res.data);

      setPatientData(res.data.patient)
    } catch (error) {
      console.error("patient value faild", error.message)
    }
  }

  useEffect(() => {
    fetchPatientInfo()
    fetchPatientAppointments()
  }, [])

  const fetchPatientAppointments = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const res = await API.get(
        `/appointments/filter?patientId=${appointmentData.patientId}&doctorId=${appointmentData.doctorId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )

      // console.log("patientAppointments",res.data.appointments);

      setPatientAppointments(res.data.appointments || [])
    } catch (err) {
      console.error("Failed to fetch patient appointments", err.message)
    }
  }

  if (!appointmentData) return <p>Loading...</p>

  const tableData = {
    columns: [
      {
        label: "Date",
        field: "date",
        sort: "des",
      },
      {
        label: "Time",
        field: "time",
        sort: "des",
      },
      {
        label: "Last appt",
        field: "from_Now",
        sort: "des",
      },

      {
        label: "Status",
        field: "status",
        sort: "asc",
      },
      {
        label: "Fees paid",
        field: "fees",
        sort: "asc",
      },
    ],
    rows: patientAppointments.map(apt => ({
      date: moment(apt.appointmentStartTime).format("YYYY-MM-DD"),
      time: moment(apt.appointmentStartTime).format("hh:mm A"),
      from_Now: moment(apt.appointmentStartTime).fromNow(),
      status: apt.StatusList?.name || "N/A",
      fees: apt.fees ? `₹${apt.fees}` : "N/A",
    })),
  }

  return (
    <div className="p-4">
      <h4>Appointment ID: {appointmentData.id}</h4>

      <Row className="mt-4">
        <Col md={6}>
          <Card>
            <CardBody>
              <h5 className="mb-4">
                <u>Appointment Information</u>
              </h5>
              <p>
                <strong>Date:</strong>
                {moment(appointmentData.appointmentStartTime).format(
                  "YYYY-MM-DD",
                )}
              </p>
              <p>
                <strong>Start Time:</strong>{" "}
                {moment(appointmentData.appointmentStartTime).format("hh:mm A")}
              </p>
              <p>
                <strong>Doctor Name:</strong> {appointmentData.Doctor?.fname}
                {appointmentData.Doctor?.lname}
              </p>

              <Label className="mt-3">
                <strong>Status</strong>
              </Label>

              <Input
                type="select"
                name="statusId"
                id="statusId"
                value={selectedStatusId}
                onChange={e => {
                  setSelelctedStatusId(e.target.value)
                  updateStatus(e.target.value)
                }}
              >
                <option value="">-- Select Status --</option>
                {statusList.map(s => (
                  <option key={s.id} value={String(s.id)}>
                    {s.name}
                  </option>
                ))}
              </Input>
            </CardBody>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <CardBody>
              <h5 className="mb-4">
                <u> Patient Information</u>
              </h5>
              <p>
                <strong>Name: </strong> {patientData?.fname}
                {patientData?.lname}
              </p>
              <p>
                <strong>Phone: </strong> {patientData?.phone}
              </p>
              <p>
                <strong>Email: </strong> {patientData?.email}
              </p>
              <p>
                <strong>gender: </strong>
                {patientData?.gender}
              </p>
              <p>
                <strong>state: </strong>
                {patientData?.state}
              </p>
              <p>
                <strong>city: </strong>
                {patientData?.city}
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <h5 className="mt-5">Patient's Appointment History</h5>
      <Card className="mt-3">
        <CardBody>
          <MDBDataTable striped bordered small data={tableData} />
        </CardBody>
      </Card>
    </div>
  )
}

export default AppointmentDetails
